function getSearchURLParams(url)
{
    if(typeof url !== "string") {
        return {};
    }
   var urlSplit = url.split("?");
   if(urlSplit.length < 2) {
       return {};
   }
   return _.object(_.map(urlSplit[1].split("&"), function(params) {
       return params.split("=");
   }));
}
var jQuery = require("jQuery");
function getSuitelet(script, deploy) {
   return {"customscript_ns_sc_sl_blog_entity_loader:customdeploy_ns_sc_sl_blog_entity_loader":"/app/site/hosting/scriptlet.nl?script=1618&deploy=1&compid=4953269&ns-at=AAEJ7tMQxqSC2uqAE6G7deM-dhEJdaELTWCs-lK5f1JLQybYrZk","customscript_ns_sc_sl_blog_post_searcher:customdeploy_ns_sc_sl_blog_post_searcher":"/app/site/hosting/scriptlet.nl?script=1620&deploy=1&compid=4953269&ns-at=AAEJ7tMQArcdTkwYkoqHZNU1Js5kVpijjsrSHmLZHq_shxHNjKg","customscript_ns_sc_sl_blog_url_prov:customdeploy_ns_sc_sl_blog_url_prov_dep":"/app/site/hosting/scriptlet.nl?script=1619&deploy=1&compid=4953269&ns-at=AAEJ7tMQbzr1lapOn8nxemWn1wKxi4SoSPNj-tULAvYMd_lMF10"}[script + ":" + deploy];
}
var xhrFactory = jQuery.ajaxSettings.xhr;
jQuery.ajaxSettings.xhr = function() {
   var xhr = xhrFactory.apply(this, arguments);
   var open = xhr.open;
   xhr.open = function () {
        var url = arguments[1];
        var assocParams = getSearchURLParams(url);
        if(assocParams.hasOwnProperty("script") && assocParams.hasOwnProperty("deploy")) {
            var hashed = getSuitelet(assocParams["script"], assocParams["deploy"]);
            if(hashed) {
                var hashedParams = getSearchURLParams(hashed);
                var keys = Object.keys(assocParams);
                for (var i=0; i<keys.length; i++) {
                    var key = keys[i];
                    var value = assocParams[key];
                    if(!hashedParams.hasOwnProperty(key))
                    {
                        hashed += "&" + key + "=" + value;
                    }
                }
                arguments[1] = hashed;
            }
        }
        return open.apply(this, arguments);
    }
    return xhr;
}